import { render } from "./ContributorHit.vue?vue&type=template&id=d13cfae2"
import script from "./ContributorHit.vue?vue&type=script&lang=js"
export * from "./ContributorHit.vue?vue&type=script&lang=js"

import exportComponent from "/app/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__